import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-2" }

import type { UserClientDto } from '@/models/client'
import * as userClientService from '@/services/userClientService'
import { useClientStore } from '@/stores/ClientStore'
import { useLanguageStore } from '@/stores/LanguageStore'
import { InputText, Select } from 'primevue'
import { ref, computed, onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientSelect',
  props: {
    modelValue: {},
    disabled: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const languageStore = useLanguageStore()
const clientStore = useClientStore()
const loading = ref(false)
const options = ref<UserClientDto[]>([])
const searchQuery = ref('')

let debounceTimer: ReturnType<typeof setTimeout> | null = null

const selectedId = computed({
  get: () => props.modelValue ?? null,
  set: (v) => emit('update:modelValue', v),
})

async function loadClients(search?: string) {
  loading.value = true
  try {
    const res = await userClientService.getMyClients(search, 10)
    const results = [...res.data]
    const currentId = clientStore.currentClientId
    if (currentId && !results.find((c) => c.id === currentId)) {
      const currentRes = await userClientService.getCurrentClient()
      if (currentRes.data) results.unshift(currentRes.data)
    }
    options.value = results
  } catch {
    // keep existing options
  } finally {
    loading.value = false
  }
}

onMounted(() => loadClients())

function onShow() {
  loadClients(searchQuery.value || undefined)
}

function onHide() {
  searchQuery.value = ''
}

function onSearchInput() {
  if (debounceTimer) clearTimeout(debounceTimer)
  debounceTimer = setTimeout(() => loadClients(searchQuery.value || undefined), 300)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Select), {
    modelValue: selectedId.value,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedId).value = $event)),
    options: options.value,
    "option-label": "fullName",
    "option-value": "id",
    placeholder: _unref(languageStore).t('general.selectClient'),
    class: "w-full text-sm",
    loading: loading.value,
    disabled: __props.disabled,
    onShow: onShow,
    onHide: onHide,
    onChange: _cache[3] || (_cache[3] = ($event: any) => (emit('change')))
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(InputText), {
          modelValue: searchQuery.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
          placeholder: _unref(languageStore).t('general.search'),
          class: "w-full text-sm",
          onInput: onSearchInput,
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
        }, null, 8, ["modelValue", "placeholder"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "options", "placeholder", "loading", "disabled"]))
}
}

})